import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { Search, Music, ChevronRight, Trash2, Plus } from 'lucide-react';

export default function AdminReleasesPage() {
  const navigate = useNavigate();
  const [releases, setReleases] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('in_review');
  const [search, setSearch] = useState('');
  const [filterUser, setFilterUser] = useState('');
  const [users, setUsers] = useState([]);

  useEffect(() => { (async () => { try { const { data } = await api.get('/admin/users?limit=500'); setUsers((data.users||[]).filter(u=>u.role!=='admin')); } catch(e){} })(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (status) params.append('status', status);
      if (search) params.append('search', search);
      if (filterUser) params.append('user_id', filterUser);
      const { data } = await api.get(`/admin/releases?${params}`);
      setReleases(data.releases); setTotal(data.total);
    } catch (err) { toast.error('Errore'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [status, search, filterUser]);

  const deleteRelease = async (e, id, title) => {
    e.preventDefault(); e.stopPropagation();
    if (!window.confirm(`Eliminare la release "${title}" e tutte le sue tracce? Azione irreversibile.`)) return;
    try { await api.delete(`/admin/releases/${id}`); toast.success('Release eliminata'); load(); }
    catch (err) { toast.error(err.response?.data?.error || 'Errore'); }
  };

  const statusColors = { draft:'bg-gray-600', in_review:'bg-yellow-600', approved:'bg-blue-600', rejected:'bg-red-600', distributed:'bg-green-600', takedown_requested:'bg-orange-600', removed:'bg-gray-700' };
  const statusLabels = { draft:'Bozza', in_review:'Revisione', approved:'Approvata', rejected:'Rifiutata', distributed:'🟢 Live', takedown_requested:'Take Down', removed:'Rimossa' };

  return (
    <div>
      <div className="flex items-center justify-between mb-6"><h1 className="text-2xl font-bold text-white">Gestione Release <span className="text-gray-500 text-lg">({total})</span></h1><button onClick={()=>navigate('/admin/releases/create')} className="px-4 py-2 bg-yellow-500 text-black rounded-lg font-medium text-sm hover:bg-yellow-400 inline-flex items-center gap-2"><Plus size={16}/>Carica Release</button></div>
      <div className="flex gap-3 mb-6 flex-wrap">
        <div className="relative flex-1 min-w-[200px]"><Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" /><input className="input-field-dark pl-10" placeholder="Cerca..." value={search} onChange={e => setSearch(e.target.value)} /></div>
        <select className="input-field-dark w-48" value={filterUser} onChange={e => setFilterUser(e.target.value)}><option value="">Tutti gli utenti</option>{users.map(u => <option key={u.id} value={u.id}>{u.first_name} {u.last_name}</option>)}</select>
        {['in_review','approved','distributed','rejected','draft',''].map(s => (
          <button key={s} onClick={() => setStatus(s)} className={`px-3 py-2 rounded-lg text-xs font-medium transition ${status === s ? 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/30' : 'bg-gray-800 text-gray-400 border border-gray-700'}`}>
            {s === '' ? 'Tutte' : s === 'in_review' ? 'Revisione' : s === 'approved' ? 'Approvate' : s === 'distributed' ? 'Live' : s === 'rejected' ? 'Rifiutate' : 'Bozze'}
          </button>
        ))}
      </div>
      {loading ? <div className="flex justify-center py-16"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400" /></div> : (
        <div className="space-y-3">
          {releases.map(r => (
            <div key={r.id} className="card-dark p-4 flex items-center gap-4">
              <Link to={`/admin/releases/${r.id}`} className="flex items-center gap-4 flex-1 min-w-0">
                <div className="w-12 h-12 rounded-lg bg-gray-700 flex-shrink-0 overflow-hidden">
                  {r.cover_art_path
                    ? <img src={`/uploads/artwork/${r.user_id}/${r.cover_art_path}`} alt="" className="w-full h-full object-cover"/>
                    : <Music size={18} className="m-auto mt-3 text-gray-500" />}
                </div>
                <div className="flex-1 min-w-0"><h3 className="font-medium text-white truncate">{r.title}</h3><p className="text-xs text-gray-400">{r.release_artist_names || '—'} · {r.first_name} {r.last_name} · {r.label_name} · {r.track_count} tracce · {r.release_type}</p></div>
              </Link>
              <span className={`text-[10px] px-2.5 py-1 rounded-full text-white ${statusColors[r.status]}`}>{statusLabels[r.status] || r.status}</span>
              <button onClick={(e) => deleteRelease(e, r.id, r.title)} className="p-2 text-gray-600 hover:text-red-500"><Trash2 size={16} /></button>
              <Link to={`/admin/releases/${r.id}`}><ChevronRight size={16} className="text-gray-600" /></Link>
            </div>
          ))}
          {releases.length === 0 && <div className="text-center py-12 text-gray-500">Nessuna release trovata</div>}
        </div>
      )}
    </div>
  );
}
